import _ from 'lodash'
import actions from './actions'
import api from '../../lib/Api'
import { push } from 'connected-react-router'
import { addNotification } from '../notifications'

const fetchSite = siteId => {
  return async dispatch => {
    dispatch(actions.fetchingSites())
    try {
      const response = await api.get(`/sites?siteId=${siteId}`)
      dispatch(actions.fetchingSitesSuccess(response.data))
    } catch (error) {
      dispatch(actions.fetchingSitesError(error))
    }
  }
}

const fetchSites = criteria => {
  return async dispatch => {
    dispatch(actions.fetchingSites())
    dispatch(actions.setSiteSearchCriteria(criteria))
    const params = Object.keys(criteria)
      .map(key => key + '=' + criteria[key])
      .join('&')
    try {
      const response = await api.get(`/sites?${params}`)
      dispatch(actions.fetchingSitesSuccess(response.data))
      if (response.data.length === 1)
        dispatch(push(`/css-admin/sites/${response.data[0].id}`))
    } catch (error) {
      dispatch(actions.fetchingSitesError(error))
    }
  }
}

export const mergeSite = mergeSiteParameters => {
  return async function(dispatch) {
    const { siteId, primarySiteId, isPreview } = mergeSiteParameters
    dispatch(actions.mergingSite())
      try {
        const response = await api.put(`/sites/${siteId}/move`, {
          primarySiteId: primarySiteId,
          isPreview: isPreview
        })

        if (!isPreview){
          dispatch(
            addNotification({
              color: 'success',
              text: `You have sucessfully merged Site ${siteId} into Site ${primarySiteId}`,
            }),
          )
        }
        const data = response.data !== '' ? response.data : null
        data.isPreview = isPreview
        dispatch(actions.mergingSiteSuccess(data))
      } catch (error) {
        const errorMessage = error.response.data
        dispatch(
          addNotification({
            color: 'danger',
            text: errorMessage,
          }),
        )
        dispatch(actions.mergingSiteError(errorMessage))
      }
  }
}

const updateSite = site => {
  return async (dispatch, getState) => {
    dispatch(actions.updatingSite())
    try {
      // If the site doesn't have preferences, set them to the default values
      
      if (site && !site.sitePreferences) {
        const sitePreferencesResponse = await api.get(`/sites/preferencedefaults`)
        site.sitePreferences = sitePreferencesResponse.data
      }

      const response = await api.put(`/sites/${site.id}`, site)
      dispatch(actions.updatingSiteSuccess(response.data))
      dispatch(
        addNotification({
          color: 'success',
          text: 'Site successfully updated',
        }),
      )
      // need to fetch site again after update because the PUT call returns no data
      fetchSites({ siteId: site.id })(dispatch, getState)
    } catch (error) {
      const { response } = error
      const message = response.data || error.message
      dispatch(
        addNotification({
          color: 'danger',
          text: `An Error has occured during update: ${message}`,
        }),
      )
      dispatch(actions.updatingSiteError(error))
    }
  }
}

const fetchSiteUsers = siteId => {
  return async (dispatch, getState) => {
    const state = getState()
    const siteUsersData = state.sitesManager.siteUsers.data
    if (siteUsersData && siteUsersData[siteId]) return
    dispatch(actions.fetchingSiteUsers())

    try {
      const response = await api.get(`/sites/${siteId}/siteUsers`)
      dispatch(actions.fetchingSiteUsersSuccess(siteId, response.data))
    } catch (error) {
      dispatch(actions.fetchingSiteUsersError(error))
    }
  }
}

const createSiteUser = (siteUser, sendEmail = true, selectedSite) => {
  return async dispatch => {
    const { siteId } = siteUser || {}

    dispatch(actions.creatingSiteUser())

    try {
      const response = await api.post(
        `/sites/${siteId}/siteUsers?sendEmail=${sendEmail}`,
        siteUser,
      )
      const newSiteUser = response.data
      dispatch(
        addNotification({
          color: 'success',
          text: sendEmail
            ? `${newSiteUser.inviteEmail} was added to ${selectedSite.name} and was sent an email notification`
            : `${newSiteUser.inviteEmail} was added to ${selectedSite.name}`,
        }),
      )
      dispatch(actions.creatingSiteUserSuccess(response.data))
    } catch (error) {
      dispatch(
        addNotification({
          color: 'info',
          text: `The user ${siteUser.inviteEmail} is already a member of this site.`,
        }),
      )
      dispatch(actions.creatingSiteUserError(error))
    }
  }
}

const createSiteUsers = (siteId, siteUsers, sendEmail) => {
  return async dispatch => {
    dispatch(actions.creatingSiteUsers())

    try {
      const response = await api.patch(
        `/sites/${siteId}/siteUsers?sendEmail=${sendEmail}`,
        siteUsers,
      )
      const newSiteUsers = response.data.createdItems
      const failedSiteUsers = response.data.failedItems
      const invalidSiteUsers = response.data.invalidItems
      dispatch(
        actions.creatingSiteUsersSuccess(
          siteId,
          newSiteUsers,
          failedSiteUsers,
          invalidSiteUsers,
          sendEmail,
        ),
      )
    } catch (error) {
      dispatch(actions.creatingSiteUsersError(error))
    }
  }
}

const updateSiteUser = (siteUser, notification) => {
  return async dispatch => {
    dispatch(actions.updatingSiteUser())
    const msgParams = {
      role: siteUser.roles[0],
      email: siteUser.inviteEmail,
    }

    try {
      await api.put(
        `/sites/${siteUser.siteId}/siteUsers/${siteUser.id}`,
        siteUser,
      )
      dispatch(actions.updatingSiteUserSuccess(siteUser))
      dispatch(
        addNotification({
          color: 'success',
          text: notification.successMessage(msgParams),
        }),
      )
    } catch (error) {
      dispatch(actions.updatingSiteUserError(error))
      dispatch(
        addNotification({
          color: 'danger',
          text: notification.errorMessage(msgParams),
        }),
      )
    }
  }
}

const remindSiteUser = siteUser => {
  return async dispatch => {
    dispatch(actions.remindingSiteUsers())

    try {
      await api.post(
        `/sites/${siteUser.siteId}/siteusers/${siteUser.id}/remind`,
      )
      dispatch(
        addNotification({
          color: 'success',
          text: `You've sent a reminder to ${siteUser.inviteEmail}`,
        }),
      )
      dispatch(actions.remindingSiteUserSuccess())
    } catch (error) {
      dispatch(
        addNotification({
          color: 'danger',
          text: `We weren't able to remind ${siteUser.inviteEmail}. Please try again later.`,
        }),
      )
      dispatch(actions.remindingSiteUserError(error))
    }
  }
}

const remindSiteUsers = (siteId, emailFilters) => {
  return async dispatch => {
    dispatch(actions.remindingSiteUsers())

    try {
      await api.post(`/sites/${siteId}/siteusers/remind`, emailFilters)
      // TODO: Should we be calculating the total affect users, or should the API return the number of emails it sent?
      dispatch(
        addNotification({
          color: 'success',
          text: `Bulk notifications sent`,
        }),
      )
      dispatch(actions.remindingSiteUsersSuccess())
    } catch (error) {
      dispatch(
        addNotification({
          color: 'danger',
          text: `Something went wrong: ${error.message}`,
        }),
      )
      dispatch(actions.remindingSiteUsersError(error))
    }
  }
}

const resetBulkAddUsers = () => {
  return async dispatch => {
    dispatch(actions.resetBulkAddUsers())
  }
}

export const siteOrgNetSuiteCustomerSearch = ({ nsCustomerId, orgId }) => {
  return new Promise((resolve, reject) =>
    siteOrgNetSuiteCustomerSearchDebounced({
      nsCustomerId,
      orgId,
      resolve,
      reject,
    }),
  )
}

const siteOrgNetSuiteCustomerSearchDebounced = _.debounce(
  async ({ nsCustomerId, orgId, resolve, reject }) => {
    try {
      const response = await api.get(
        `/sites?NSCustomerId=${nsCustomerId}&OrganizationId=${orgId}`,
      )
      resolve(response)
    } catch (err) {
      reject(err)
    }
  },
  300,
)

export default {
  createSiteUser,
  createSiteUsers,
  fetchSite,
  fetchSites,
  fetchSiteUsers,
  mergeSite,
  updateSite,
  updateSiteUser,
  remindSiteUser,
  remindSiteUsers,
  resetBulkAddUsers,
}



// WEBPACK FOOTER //
// ./src/redux/sitesManager/operations.js